import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var TriangleUp = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_TriangleUp_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 8,
    height: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.43 5.693 3.39 3.682c.383.415.112 1.125-.428 1.125H4.608c-.54 0-.811-.71-.429-1.125l3.392-3.682a.574.574 0 0 1 .858 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_TriangleUp_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default TriangleUp;